import { isSupabaseConfigured } from "../supabase";
import { createLocalStorageExpenseStore } from "./localStorageStore";
import { createSupabaseExpenseStore } from "./supabaseStore";
import type { ExpenseStore } from "./types";

// Same pattern as `src/lib/receipts/index.ts`: pick the implementation at
// module import time. Playwright runs with VITE_E2E_BYPASS_AUTH=true, which
// forces the localStorage store so tests don't need a real Supabase project.
const useLocal =
  import.meta.env.VITE_E2E_BYPASS_AUTH === "true" || !isSupabaseConfigured;

export const expenseStore: ExpenseStore = useLocal
  ? createLocalStorageExpenseStore()
  : createSupabaseExpenseStore();

export type {
  Expense,
  ExpenseStatus,
  ExpenseStore,
  NewExpenseInput,
} from "./types";
